import { URLStorage } from "./URLStorage.js";
import { LocalStorage } from "./LocalStorage.js";
import { SyncedStorage } from "./SyncedStorage.js";
import { FallbackStorage } from "./FallbackStorage.js";
import { ZipStorage } from "./ZipStorage.js";
const urlSearchStore = new URLStorage(
  new URLSearchParams(window.location.hash.slice(1)),
  "search"
);
const urlHashStore = new URLStorage(
  new URLSearchParams(window.location.hash.slice(1)),
  "hash"
);
const urlStore = urlHashStore;
const zipUrlStore = new ZipStorage(urlStore);
const localStore = new LocalStorage(window.localStorage);
const syncedStore = new SyncedStorage(urlStore, localStore);
const fallbackStore = new FallbackStorage(urlStore, localStore);
export {
  fallbackStore,
  localStore,
  syncedStore,
  urlHashStore,
  urlSearchStore,
  urlStore,
  zipUrlStore
};
//# sourceMappingURL=index.js.map
